import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-page-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {}
